export default __webpack_public_path__ + "static/media/HeinekenSerif18-Bold.18d7a536.ttf";